import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=46194887&scoped=true&"
import script from "./formDetail.vue?vue&type=script&lang=js&"
export * from "./formDetail.vue?vue&type=script&lang=js&"
import style0 from "./formDetail.vue?vue&type=style&index=0&id=46194887&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46194887",
  null
  
)

export default component.exports